module.exports = "pegasus/assets/blocks/column-lp3-themelp1.png";